import React from 'react';
import { Container, Grid, Box } from '@mui/material';
import ProfileSection from './components/ProfileSection';
import CarSection from './components/CarSection';
import TaskSection from './components/TaskSection';

const DashboardPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Grid container spacing={3}>
          {/* Profile Section - 6 columns */}
          <Grid item xs={12} md={4}>
            <ProfileSection />
          </Grid>
          
          {/* Car and Task Section - 6 columns */}
          <Grid item xs={12} md={8}>
            <CarSection />
            <TaskSection />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default DashboardPage; 